import { CBInfoResponse } from '@/types/api/v1/CBInfoResponse';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
const url = ApiUrl.Read.CHASH_BACK_INFO;
const useGetChashBackInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<CBInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);
  return {
    execute
  };
};
export default useGetChashBackInfo;